import { useCallback, useRef, useState } from 'react'
import styled from 'styled-components'
import { ChangePasswordData } from '@/custom-types'
import { useErrorHandlerContext, useOpeningElementsControllerContext, useUserLanguage } from '@/customHooks'
import { Col, Row } from 'react-grid-system'
import { Button, RowSpacer } from '../atoms'
import textsData from '@/textData/UserProfileTexts.json'
import { ProfileChangePasswordFormControlled } from './ProfileChangePasswordFormControlled'
import { useChangePasswordMutation } from '@/graphql/generated'

const FormWrapper = styled.div`
  background-color: white;
  border-radius: ${({ theme }) => theme.border.radius.md};
  padding: 2rem;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);
`

export const UserProfileChangePasswordForm = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en
  
  const passwordDataRef = useRef<ChangePasswordData | null>(null)

  const [key, setKey] = useState(1)

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()

  const [changePassword, { loading: changePasswordMutationLoading }] = useChangePasswordMutation()
  
  const { open: errorHandle } = useErrorHandlerContext()

  const onChangeHandle = useCallback((profileData: ChangePasswordData) => {
    passwordDataRef.current = profileData
  }, [])


  const onConfirmHandle = () => {
    if (!passwordDataRef.current) return

    changePassword({ variables: {
      oldPassword: passwordDataRef.current.currentPassword,
      newPassword: passwordDataRef.current.newPassword
    }})
    .then((response) => {
      if (response.data?.changePassword.paswordWasUpdated) {
        confirmDialogModalOpen({
          title: texts.changePassword.confirmationDialog.title,
          description: texts.changePassword.confirmationDialog.description
        })
        passwordDataRef.current = null
        setKey((prev) => prev + 1)
      } else if (response.data?.changePassword.oldPasswordWrong) {
        confirmDialogModalOpen({
          title: texts.changePassword.failedDialog.title,
          description: texts.changePassword.failedDialog.description
        })
      }
    })
    .catch(errorHandle)
  }
  
  return (
    <>
      <RowSpacer height={3} />
      <FormWrapper>
        <ProfileChangePasswordFormControlled
          key={key}
          onChange={onChangeHandle}
        />
        <Row>
          <Col>
            <Button
              onClick={onConfirmHandle}
              isLoading={changePasswordMutationLoading}
            >
              {texts.buttons.confirm}
            </Button>
          </Col>
        </Row>
      </FormWrapper>
    </>
  )
}
